/*
 * WW Credits page localization routing
 * Author: Plaud Tayler
 * Version: 1.1.0 - 2026-09-29 11:43 (UTC+8) - Plaud Tayler — resolve region-coded language keys case-insensitively
 * Page: page.piplcrinto
 */
(function () {
  if (window.__wwCreditsPageLocales) return;
  window.__wwCreditsPageLocales = true;

  // Apply section-owned localized copy without interpreting merchant text as HTML - Plaud Tayler - 2026-09-29 11:32 - Begin
  const sectionFields = {
    overview: {
      kicker: '.ww-co__kicker',
      heading: '.ww-co__heading',
      subhead: '.ww-co__subhead',
      reassurance: '.ww-co__reassurance-copy',
      ledgerHeadMinutes: '.ww-co__ledger-head span:first-child',
      ledgerHeadCredits: '.ww-co__ledger-head span:last-child',
      ruleHeading: '.ww-co__rule-heading',
      ruleText: '.ww-co__rule-text'
    },
    guide: {
      heading: '.ww-sechead__heading',
      subhead: '.ww-sechead__sub',
      meetingKicker: '.ww-cg__meeting-head .ww-cg__label',
      meetingHeading: '.ww-cg__meeting-heading',
      meetingNote: '.ww-cg__meeting-note',
      accountKicker: '.ww-cg__account-copy .ww-cg__label',
      accountHeading: '.ww-cg__account-heading',
      accountSubhead: '.ww-cg__account-subhead'
    },
    team: {
      kicker: '.ww-ct__kicker',
      heading: '.ww-ct__heading',
      subhead: '.ww-ct__subhead'
    }
  };
  const blockFields = {
    overview: {
      label: '.ww-co__meter-label',
      status: '.ww-co__meter-status',
      title: '.ww-co__meter-title',
      body: '.ww-co__meter-body',
      footer: '.ww-co__meter-footer'
    },
    guide: {
      title: '.ww-cg__usage-title, .ww-cg__step-title, .ww-cg__account-title',
      body: '.ww-cg__usage-body, .ww-cg__step-body, .ww-cg__account-body',
      cost: '.ww-cg__step-cost'
    },
    team: {
      title: '.ww-ct__item-title',
      body: '.ww-ct__item-body'
    }
  };
  const requested = new URLSearchParams(window.location.search).get('lang')?.toLowerCase();
  const language = requested === 'jp' ? 'ja' : requested === 'es-419' ? 'es-latam' : requested;

  function setCopy(element, value) {
    if (!element || value == null || value === '') return;
    if (Array.isArray(value)) {
      element.replaceChildren(...value.map((paragraph) => {
        const node = document.createElement('p');
        node.textContent = paragraph;
        return node;
      }));
    } else {
      element.textContent = value;
    }
  }

  function applySection(section) {
    if (!language) return;
    const type = section.dataset.creditsLocaleSection;
    const source = section.querySelector('[data-credits-locale-config]');
    if (!type || !source) return;
    let translations;
    let resolvedLanguage;
    try {
      translations = JSON.parse(source.textContent);
      resolvedLanguage = Object.keys(translations).find((code) => code.toLowerCase() === language);
      translations = JSON.parse(translations[resolvedLanguage] || '');
    } catch (_error) {
      return;
    }
    const contentLanguage = language === 'es-latam' ? 'es-419' : resolvedLanguage;
    Object.entries(sectionFields[type] || {}).forEach(([key, selector]) => {
      setCopy(section.querySelector(selector), translations.fields?.[key]);
    });
    section.querySelectorAll('[data-credits-locale-block]').forEach((block) => {
      const entry = translations.blocks?.[block.dataset.creditsLocaleBlock];
      if (!entry) return;
      Object.entries(blockFields[type] || {}).forEach(([key, selector]) => {
        setCopy(block.querySelector(selector), entry[key]);
      });
    });
    if (translations.fields?.ledgerAria) {
      section.querySelector('.ww-co__ledger')?.setAttribute('aria-label', translations.fields.ledgerAria);
    }
    if (translations.fields?.usageAria) {
      section.querySelector('.ww-cg__usage')?.setAttribute('aria-label', translations.fields.usageAria);
    }
    if (type === 'overview' && translations.fields?.kicker) {
      const pageHeading = document.querySelector('#MainContent > h1.visually-hidden');
      if (pageHeading) {
        pageHeading.textContent = translations.fields.kicker;
        pageHeading.lang = contentLanguage;
      }
      document.title = translations.fields.kicker;
    }
    section.lang = contentLanguage;
  }

  function applyAll(root) {
    root.querySelectorAll('[data-credits-locale-section]').forEach(applySection);
    if (root.matches?.('[data-credits-locale-section]')) applySection(root);
  }

  applyAll(document);
  document.addEventListener('shopify:section:load', (event) => applyAll(event.target));
  // Apply section-owned localized copy without interpreting merchant text as HTML - Plaud Tayler - 2026-09-29 11:32 - End
})();
